export default __webpack_public_path__ + "static/media/n-back-acustico-step2.1a7b498e.svg";